// inputタグのinputmode一覧
const BUTTON_INPUTMODE = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset',
} as const
type BUTTON_INPUTMODE = typeof BUTTON_INPUTMODE[keyof typeof BUTTON_INPUTMODE]

/**
 * 指定したstringを返す。定義外の場合はundefinedを返す
 * @param input 入力データ
 * @returns 指定値 or undefined
 */
const toButtonType = (input: string | undefined) => {
  switch (input) {
    case BUTTON_INPUTMODE.BUTTON:
    case BUTTON_INPUTMODE.SUBMIT:
    case BUTTON_INPUTMODE.RESET:
      return input
    default:
      return undefined
  }
}

export { BUTTON_INPUTMODE, toButtonType }
